<template>
    <section class="home-container">
        <MasterPage title="患者账户">
            <div slot="title-icon">
                <Icon type="ios-contact" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="手机号：">
                            <Input v-model="phone" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="昵称：">
                            <Input v-model="name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="性别：">
                            <Select v-model="sex" clearable placeholder="请选择">
                                <Option value="0">男</Option>
                                <Option value="1" >女</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="状态：">
                            <Select v-model="isLock" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="infoModel" title="账号详情">
                <Form :label-width="100">
                    <Row>
                        <Col span="24">
                        <FormItem label="患者头像：">
                            <img :src="infoItem.profileImgUrl" style="max-height: 125px;max-width: 100%">
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者编号：">{{infoItem.id}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者名称：">{{infoItem.name}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者性别：">{{infoItem.sex==0?'男':infoItem.sex==1?'女':'-'}}</FormItem>
                        </Col>
                        <Col span="12" v-if="infoItem.pregnant">
                        <FormItem label="怀孕状态：">{{infoItem.pregnant}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者账号：">{{infoItem.phone}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者密码：">**********</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者生日：">{{infoItem.birthday | dateTimeToString}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者身高：">{{infoItem.height}}cm</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者体重：">{{infoItem.weight}}kg</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="账号状态：">{{infoItem.isLock?"已禁用":"在使用"}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="患者创建时间：">{{infoItem.createTime | dateTimeToString}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="邮箱：">{{infoItem.email}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="住址：">{{infoItem.address}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="监护人姓名：">{{infoItem.guardianName}}</FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="备用联系电话：">{{infoItem.connectPhone}}</FormItem>
                        </Col>
                        <Col span="24">
                        <FormItem label="联系人：">
                            <Table stripe max-height="250" :columns="columnsconnectInfo" :data="infoItem.connectList"></Table>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
        </Modal>
        <Modal v-model="dietLinesModel" title="原则详情" width="750">
            <!--<Collapse accordion v-if="dietLines.length > 0 ">-->
                <!--<Panel v-for="item in dietLines" :key="item.id">-->
                    <!--{{item.name}}-->
                    <!--<p slot="content">-->
                    <!--<Table stripe max-height="350" :columns="columnsInfo" :data="item.foodMaterialVOs"></Table>-->
                    <!--</p>-->
                <!--</Panel>-->
            <!--</Collapse>-->
            <div v-if="dietLines.length > 0 ">
                <Table stripe max-height="350" :columns="userDietGuidelineColumns" :data="dietLines"></Table>
            </div>
            <p v-else style="text-align: center;color: #c3c3c3;line-height: 25px">暂未绑定原则</p>

            <div style="font-weight: bold; margin: 10px 0;">禁食食材</div>
            <Form :label-width="80">
              <Row>
                  <Col span="18">
                      <FormItem label="食材名称：">
                          <Input v-model="inedibleFoodName" placeholder="请输入"/>
                      </FormItem>
                  </Col>
                  <Col span="6">
                      <FormItem>
                        <Button type="info" icon="ios-search" @click="queryInedibleFoodsLoading">查询</Button>
                      </FormItem>
                  </Col>
              </Row>
            </Form>
            <div v-if="inedibleFoods.length > 0 ">
                <Table stripe max-height="350" :columns="inedibleFoodsColumns" :loading="inedibleFoodsLoading" :data="inedibleFoods"  @on-selection-change="inedibleFoodSelectionChange"></Table>
            </div>
            <p v-else style="text-align: center;color: #c3c3c3;line-height: 25px">暂无禁食食材</p>
            <div style="display: flex; justify-content: space-between; margin-top: 10px">
                <Button type="info" @click="foodListModel = true">添加禁食</Button>
                <Button type="info" :disabled="!cancelInedibleFoodList" @click="cancelInedibleFoods">取消禁食</Button>
            </div>
        </Modal>
        <Modal v-model="foodListModel" title="添加禁食食材" width="750">
          <Form :label-width="80">
            <Row>
                <Col span="18">
                    <FormItem label="食材名称：">
                        <Input v-model="foodName" placeholder="请输入"/>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem>
                      <Button type="info" icon="ios-search" @click="findFoodItem">查询</Button>
                    </FormItem>
                </Col>
            </Row>
          </Form>
          <Table stripe max-height="350" :columns="foodColumns" :loading="foodListLoading" :data="foodList" @on-selection-change="foodSelectionChange"></Table>
          <div slot="footer">
              <Button type="text" size="large" @click="cancelFoodListModal">关闭</Button>
              <Button type="text" size="large" :disabled="!addInedibleFoodList" @click="addInedibleFoods">添加</Button>
          </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '手机号',
                        key: 'phone',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true
                    },
                    {
                        title: '昵称',
                        key: 'name',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', params.row.name)
                        }
                    },
                    {
                        title: '性别',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].sex == 0){
                                return h('span', '男')
                            }else if (this.dataList[params.index].sex == 1){
                                return h('span', '女')
                            }else{
                                return h('span', '-')
                            }
                        }
                    },
                    {
                        title: '联系人',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (params.row.connectList){
                                return h('span', params.row.connectList.length)
                            }else{
                                return h('span', '暂无')
                            }
                        }
                    },
                    {
                        title: '邮箱',
                        key: 'email',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true
                    },
                    {
                        title: '注册时间',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let value= params.row.createTime
                            if (value==undefined || value.length <=0) return
                            let time = new Date(value)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hs = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h('span', y+'-'+m+'-'+d+' '+hs+':'+mm+':'+s)
                        }
                    },
                    // {
                    //     title: '住址',
                    //     key: 'address',
                    //     align: 'center',
                    //     ellipsis: true,
                    //     tooltip: true
                    // },
                    // {
                    //     title: '监护人姓名',
                    //     key: 'guardianName',
                    //     align: 'center',
                    //     ellipsis: true,
                    //     tooltip: true
                    // },
                    // {
                    //     title: '备用联系电话',
                    //     key: 'connectPhone',
                    //     align: 'center',
                    //     ellipsis: true,
                    //     tooltip: true
                    // },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:300,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'md-analytics',
                                        label:"small",
                                        loading:this.dietLinesLoading
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.dietLinesByUser_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '查看原则'),
                            ]
                            if (this.dataList[params.index].isLock){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                dietLinesInfo:[],
                columnsconnectInfo:[
                    {
                        type: 'index',
                        width: 50,
                        align: 'center',
                    },
                    {
                        title: '联系人姓名',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '联系人号码',
                        key: 'phone',
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: '联系人地址',
                        key: 'address',
                        tooltip: true,
                        align: 'center',
                    }
                ],
                columnsInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '食材',
                        align: 'center',
                        render: (h,params) => {
                            return h('span',params.row.name+"("+ params.row.unit+")")
                        }
                    },
                    {
                        title: '原则',
                        key: 'dietText',
                        align: 'center',
                    },
                    {
                        title: '界限',
                        key: 'dietTextRemark',
                        align: 'center',
                        render: (h,params) => {
                            return h('span',params.row.detailList)
                        }
                    }
                ],
                userDietGuidelineColumns: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '原则',
                        key: 'name',
                        align: 'center'
                    },
                    {
                        title: '界限',
                        key: 'dietTextRemark',
                        align: 'center',
                        render: (h,params) => {
                            return h('span',params.row.detailList[0].name)
                        }
                    }
                ],
                tableLoading:false,
                infoModel:false,
                dietLinesModel:false,
                dietLinesLoading:false,
                dietLines:{foodMaterialVOs:[]},
                infoItem:"",
                phone:'',
                name:'',
                sex:'',
                isLock:'false',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                inedibleFoodsLoading: false,
                inedibleFoodName: '',
                inedibleFoods: [],
                inedibleFoodsColumns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '食材名称',
                        key: 'foodMaterialName',
                        align: 'center'
                    }
                ],
                foodName: '',
                foodListModel:false,
                foodListLoading: false,
                foodList: [],
                foodColumns: [
                  {
                      type: 'selection',
                      width: 60,
                      align: 'center'
                  },
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                  {
                          title: '食材名称',
                          key: 'foodMaterialName',
                          align: 'center',
                      },
                ],
                cancelInedibleFoodList: null,
                addInedibleFoodList: null,
                userId: null
            }
        },
        created(){
            this.pageFindItem()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            inedibleFoodSelectionChange(selection) {
              console.log('inedibleFoodSelectionChange: ', selection)
              this.cancelInedibleFoodList = selection.length > 0 ? selection.map(item => item.foodMaterialId).join(',') : null
            },
            foodSelectionChange(selection){
              console.log('selection: ', selection)
              this.addInedibleFoodList = selection.length > 0 ? selection.map(item => item.foodMaterialId).join(',') : null
            },
            findFoodItem() {
                if (this.foodName.trim() == '' || this.foodName.trim() == null) {
                  this.$Notice.error({title: '请输入食材名称'});
                  return
                }
                this.$Message.loading('正在加载中。。。')
                this.foodListLoading = true
                this.$http.post('drools/getAllEdibleFood', {
                    name: this.foodName,
                    user_id: this.userId,
                }).then(function (res) {
                    this.foodListLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.foodList = msg.data
                    } else {
                        this.$Notice.error({title: '食材查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.foodListLoading = false
                    this.myError(res.body)
                })
            },
            cancelFoodListModal() {
              this.foodName = null;
              this.foodListModel = false;
            },
            addInedibleFoods() {
                this.$Message.loading('请求处理中。。。')
                this.$http.post('foodMaterial/addInedibleList',{
                  foodIdList: this.addInedibleFoodList,
					        userId: this.userId
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title:'添加禁食成功',desc: msg.message});
                        this.queryInedibleFoodsLoading()
                        this.cancelFoodListModal()
                    }else {
                        this.$Notice.error({title:'添加禁食失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            cancelInedibleFoods() {
              if(this.cancelInedibleFoodList == null || this.cancelInedibleFoodList.length <= 0) {
                this.$Notice.error({title:'请先选择食材'});
                return
              }
                this.$Message.loading('请求处理中。。。')
                this.$http.post('foodMaterial/cancelInedibleList',{
                  foodIdList: this.cancelInedibleFoodList,
					        userId: this.userId
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                      this.dietLinesModel = false;
                      this.$Notice.success({title:'取消禁食成功',desc: msg.message});
                    }else {
                        this.$Notice.error({title:'取消禁食失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('user/list',{
                    phone:this.phone,
                    name:this.name,
                    sex:this.sex == undefined ? '':this.sex,
                    isLock:this.isLock,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                    order: 'DESC'
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        console.log(msg.data.list)
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.infoModel = false
                this.questionnaireId = ''
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用患者账户“'+ item.phone + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('user/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '患者账户禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'患者账户禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用患者账户“'+item.phone + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('user/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '患者账户启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'患者账户启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            dietLinesByUser_modal(item){
              this.userId = item.id
                this.dietLinesLoading = true
                this.$http.post('user/getDietLinesByUser',{
                    userId:item.id,
                }).then(function (res) {
                    this.dietLinesLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dietLinesModel = true
                        this.dietLines = msg.data
                    }else {
                        this.$Notice.error({title:'原则查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.dietLinesLoading = false
                    this.myError(res.body)
                })
                this.inedibleFoodName = null
                this.queryInedibleFoodsLoading()
            },
            queryInedibleFoodsLoading() {
              this.inedibleFoodsLoading = true
              this.$http.post(`drools/getAllInedibleFood`, {
                    name: this.inedibleFoodName,
                    user_id: this.userId,
                }).then(function (res) {
                  this.inedibleFoodsLoading = false
                  let msg = res.body
                  if (msg.success) {
                      this.inedibleFoods = msg.data
                  }else {
                      this.$Notice.error({title:'禁食食材查询失败',desc: msg.message});
                  }
              },function (res) {
                  this.inedibleFoodsLoading = false
                  this.myError(res.body)
              })
            }
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    @font-face {
        font-family: 'iconfont';  /* project id 1253004 */
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot');
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff') format('woff'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.svg#iconfont') format('svg');
    }

    .iconfont{
        font-family:"iconfont" !important;
        font-size:14px;font-style:normal;
        padding-right: 5px;
        -webkit-font-smoothing: antialiased;
        -webkit-text-stroke-width: 0.2px;
        -moz-osx-font-smoothing: grayscale;
    }

    .home-container{

    }

    .questionnaireTitle{
        text-align: center;
        font-size: 42px;
        font-weight: bold;
    }

    .questionnaireQuestion{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 30px;
    }

    .questionTitle{
        font-size: 20px;
        line-height: 50px;
        letter-spacing: 3px;
        position: relative;
    }

    .my_Button{
        height: 45px;
        border: 0;
        padding: 5px 13px 6px;
        background-color: rgba(0,0,0,0);
    }

    .my_Button:focus{
        box-shadow: 0 0 0 0;
    }

    .my_divz{
        height: 35px;
        padding: 4px 7px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        background-color: #fff;
        line-height: 27px;
        font-size: 18px;
    }
</style>
